import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CutoffService } from 'src/app/services/cutoff.service';
import { InventorysService } from 'src/app/services/inventory.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { ProjectDiagramationImagesComponent } from '../project-diagramation-images/project-diagramation-images.component';

@Component({
  selector: 'app-project-diagramation-resumen',
  templateUrl: './project-diagramation-resumen.component.html',
  styleUrls: ['./project-diagramation-resumen.component.scss']
})
export class ProjectDiagramationResumenComponent implements OnInit {

  displayedColumns: string[] = [];
  allColumns: string[] = [];

  medio: string = '';
  alias: string = '';
  elemento_pop: string = '';
  posicion: string = '';
  descripcion: string = '';
  comentarios: string | null | undefined;
  sucursales: number = 0;
  vendidos: number = 0;
  id_proy: number = 0;
  id_camp: number = 0;
  id_medio: number = 0;
  id_pop: number = 0;
  filtros_sucursal: any = [];
  dt_totales: any = [];
  inventario_type: number = 0;
  promociones: any = [];
  promSeleccionadas: any = [];
  fecha_upd: string = '';
  nombre_usuario: string = '';
  id_diagramacion: number = 0;
  viewSucursales: boolean = false;
  sucursalesArr: any = [];
  colsSucursales: string[] = ["Plaza","FarmID","Nombre"];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private invService : InventorysService,
    private projectService : ProjectsService,
    private _cutoffS : CutoffService,
    private main: MainService,
    private matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.medio = this.data.medio;
    this.alias = this.data.alias;
    this.elemento_pop = this.data.pop;
    this.posicion = this.data.posicion;
    this.descripcion = this.data.descripcion;
    this.comentarios = this.data.comentarios ? this.data.comentarios : '';
    this.sucursales = this.data.cant_sucursales;
    this.vendidos = this.data.cantidad;
    this.id_proy = this.data.id_proyecto;
    this.id_camp = this.data.project.id_proy_camp;
    this.id_medio = this.data.id_medio;
    this.id_pop = this.data.id_pop;
    this.inventario_type = this.data.inventario_type;
    this.promociones = this.data.promociones;
    this.fecha_upd = this.data.updated_at.substring(0,10);
    this.nombre_usuario = this.data.nombre_usuario;
    this.id_diagramacion = this.data.id;
    this.getInventory();
    this.getPromotionsFile();
    this.getSucursales();
  }

  getInventory(){
    this.main.ShowLoading();
    this.invService.getInventory(this.id_proy, this.id_camp, this._cutoffS, this.id_medio, this.id_pop, this.filtros_sucursal).then((res_dt_totales:any)=>{
      if(this.inventario_type == 1) this.dt_totales = res_dt_totales.filter((rd:any)=>rd.id_medio==this.id_medio);
      else this.dt_totales = res_dt_totales.filter((rd:any)=>rd.id_medio==this.id_medio&&rd.id_pop==this.id_pop);
  
      this.dt_totales = Array.from(
        new Map(this.dt_totales.map((item: any) => [item.atributo, item])).values()
      );    
      this.main.HideLoading();
    });
  }

  getPromotionsFile(){
    this.projectService.getPromotionData(this.id_camp).subscribe((x: any) => {
      this.promSeleccionadas = x.data.filter( (obj:any) => this.promociones.includes(obj["CODIGO PRINCIPAL"]));
      if(this.promSeleccionadas != undefined){
        if(x.columnas.length > 0){
          this.displayedColumns = x.columnas;
          this.displayedColumns = this.displayedColumns.map(col => col);

          if (!this.displayedColumns.includes('CODIGO PRINCIPAL')) {
            this.displayedColumns.unshift('CODIGO PRINCIPAL');
          }
          this.allColumns = [...this.displayedColumns];        
        }
        else{
          this.displayedColumns = Object.keys(this.promSeleccionadas[0]).filter(key => key && key.trim() !== '');
          this.allColumns = [...this.displayedColumns];
        } 
      } 
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })
  }

  getSucursales(){

    let suc_id  = this.data.pop_config[0].sucursales.map((m:any)=>m.id);

    this.projectService.getSucursalesById(suc_id).subscribe((x: any) => {
      this.sucursalesArr  = x.data;
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })

  }

  verImagenes(){
      this.matDialog.open(ProjectDiagramationImagesComponent, {
        panelClass: ['dialogs-md'],
          data: {
            id: this.id_diagramacion,
            type: 2
          }
        }).afterClosed().subscribe(
        resp => {
        }
      );
  }

  openSucursales(){
    this.viewSucursales = !this.viewSucursales;
  }
}
